import { _,$,Backbone,Radio,Foundation } from '../../vendor'
import { Biscuit,IcsBuilder } from '../utils'
import InboomaBaseController from './InboomaBaseController'
import Order from '../models/Order'
import Reservation from '../models/Reservation'

import linksMap from './OrdersControllerAccessBarMap'
import OrdersSidebarView from '../views/orders/OrdersSidebarView'
import OrdersSortTabs from '../views/orders/OrdersSortTabs'
import OffCanvasOrdersForm from '../views/orders/OffCanvasOrdersForm'
import OrdersView from '../views/orders/OrdersView'
import OrdersCalendarView from '../views/orders/OrdersCalendarView'
import CheckinOutView from '../views/orders/CheckinOut'
import QuickOrderForm from '../views/orders/QuickOrderForm'
import OrdersExportView from '../views/orders/OrdersExportView'
import GetGroupListView from '../views/orders/GetGroupListView'

import OrdersViewTpl from '../templates/orders/OrdersTpl.html'

import OffCanvasAddPayment from '../views/orders/OffCanvasAddPayment'
import ReservationsList from '../collections/ReservationsList'

/**
 * To access orders collection in this file, always use this._collection
 */
export default InboomaBaseController.extend({

    _channelName: 'orders',
    _el: '#inb-c-main-orders',
    _template: OrdersViewTpl,

    _filterSidebar : {},           // used to restore filter settings after opening off canvas forms
    _canvasToOpen : {
        source: null,                // return to source canvas (if set) after closing destination canvas
        destination: null            // open destination canvas if set (e.g. open 'addpayment' after closing 'edit')
    },
    _controllerHistory : {
        currentController : {},       // currently called controller
        previousController : {},      // previously called controller
        beforePrevCtrl : {}           // controller called before previous controller
    },
    _orderToRefetch : 0,              // order id to refetch the collection, nothing to refetch if value is zero

    _accessBarMap () {
        return {
            model: Order,
            collection: this.collection,
            pageTitle: this.t('orders',null,'capital'),
            searchPlaceholder: this.t('order_nbr'),
            linksMap: linksMap()
        }
    },

    _shouldRenderLayout () {
        return (document.querySelector(this._el) === null
             || document.querySelector('.help-link') === null
             || (document.querySelector('.help-link') !== null
              && document.querySelector('.help-link').getAttribute('href') === '/reservationsList/help')
             || document.querySelector('#calendar') !== null
             || document.querySelector('#inb-checkin') !== null)
    },

    setCanvasToOpen (source, destination) {
        this._canvasToOpen = { source, destination };
    },

    initialize () {

        const that = this,
              app = Radio.channel('app');

        // listen to router channel to update controller history
        app.on('router:history', (history) => {
            that._controllerHistory.currentController = history.currentController;
            that._controllerHistory.previousController = history.previousController;
            that._controllerHistory.beforePrevCtrl = history.beforePrevCtrl;
        });
    },

    /**
     * @routes /orders
     *         /orders:order_id -> Highlight & toggle order
     */
    index (options = null) {
        if(options !== 'calendar') {
            window.location.replace("/reservations/orders");
        }
        this._collection._pagination.current_page = 0;
        this._collection._refetchCollection();
        // work-around to fix routing issue of double overlays
        _.each($('.js-off-canvas-overlay'),(overlay) => {
            $(overlay).removeClass('is-visible');
        });

        if (!this._shouldRenderLayout()) {
            // Nothing to do - use idle to fetch for any collection updates
            // (Called e.g. after saving a new order)
            if (typeof this._collection._refetchCollection !== 'undefined') {
                this._collection._pagination.current_page = 0;
                this._collection._refetchCollection();
            }

            this._processOpenCanvasQueue();

            return;
        }
      
        this._updateCollection();
        if (this._controllerHistory.previousController.name == "orders" && this._controllerHistory.previousController.method == "checkinOut"  && this._orderToRefetch > 0) {

            const that = this;
            var currentPage = 0;
                for (var i = 0; i < this._collection.models.length; i++) {
                    if (this._collection.models[i].id == this._orderToRefetch) {
                        // get current page
                        currentPage = parseInt(i / this._collection._pagination.limit);
                        break;
                    }
                }

            this._collection._pagination.current_page = currentPage-1;          // set page to refetch
   
            this._collection._refetchCollection(true, (success) => {            // keep collection data -> only update requested page, reload collection view afterwards
                this._collection._pagination.current_page = parseInt(this._collection.models.length / this._collection._pagination.limit);      // reset current page
                that.index(options);
            });
            this._orderToRefetch = 0;
            return;
        }
        this._resetOptions(options);

        if ($('.help-link').attr('href') !== '/orders/help') {

            // @todo Very lazy way to check whether own view is in scope ^^

            if (this.el === 'undefined') {
                this.el = "#inb-c-main-orders";
            }

            this.ordersView = new OrdersView({
                collection: this._collection,
                widgetMode: this.widgetMode,
                el: this.el,
                toggleId: (!isNaN(options) ? Number(options) : null)
            });
        }

        if (!this.widgetMode) {
            if (typeof this.ordersSidebarView !== 'undefined' && typeof this.ordersSortTabsView !== 'undefined') {   
                // previous views and all child views stucking in memory
                this.ordersSidebarView.destroy();
                this.ordersSortTabsView.destroy();
            }
            
            this.ordersSidebarView = new OrdersSidebarView({ collection: this._collection, model: Order, controller: this });
            this.ordersSortTabsView = new OrdersSortTabs({ collection: this._collection, model: Order});
        }

        this._processOpenCanvasQueue();
    },

    /**
     * @routes /orders/:orderId/checkin/:reservationId
     */
    checkinOut (orderId, reservationId) {

        // fetch reservation instead of order
        const RequestHelper = Backbone.Model.extend({ urlRoot : '/reservations/'+reservationId + '?find=full' });

        (new RequestHelper(null)).fetch({
            success (model, response) {

                if (response.success && response.data.id != undefined) {
                    const checkinOutView = new CheckinOutView({
                        model : new Reservation(response.data)
                    });
                }
                else {
                    console.log("ERROR: failed to get reservation");
                }
            },
            error (model, response) {
                console.log("Error, could not request reservation.");
            }
        });

        this._orderToRefetch = orderId;
        /*
        this._collection.fetchById(orderId, (order) => {
            
            const checkinOutView = new CheckinOutView({
                model : order.get('reservations')
                            .get(reservationId)
            });
        });
*/
    },

    ordersExport () {
        const ordersExportView = new OrdersExportView();
    },

    getGroupList () {
        const getGroupListView = new GetGroupListView();
    },

    /**
     * @routes /orders/help
     */
    ordersHelp () {

        new Foundation.Reveal($('.inb-orders-help-modal')).open();

        $('.inb-orders-help-modal').on('closed.zf.reveal', function() {
            Backbone.history.navigate('reservations/orders');
            $('.inb-orders-help-modal').off('closed.zf.reveal');
        });

    },

    /**
     * @routes /orders/add
     *         /orders/:orderId/:reservationId
     *         /orders/:orderId/:action[str "add" / options]
     *
     */
    ordersForm (orderId, action, reservationId = '', canvas) {


        let model = this._collection.get(orderId);
        const that = this;

        if (typeof model !== 'undefined') {
            //this.index();
        }
        
        // @todo not beautiful:
        model = new Order();
        
        let toggleAddReservation = false,
            toggleReservation = null;

        if (orderId && action == 'add') {
          if (orderId) {
            toggleAddReservation = true;
            model = this._collection.get(orderId);
          }
        } else if (action == 'edit' && reservationId !== '') {
          toggleReservation = reservationId;
          model = this._collection.get(orderId);
        } else if (action == 'addpayment') {
          model = this._collection.get(orderId);
        } else if (action == 'addpaymentfromwallet') {
            model = this._collection.get(orderId);
        } else if (action == 'addpaymentfromreservations') {
            model = this._collection.get(orderId);
        } else if (action == 'addpaymentfromorders') {
            model = this._collection.get(orderId);
        } else if (action == 'addpaymentfromorderedit') {
            model = this._collection.get(orderId);
        }else {
            Backbone.history.navigate('reservations/orders', { trigger:true });
        }

        // @todo Find generic approach for controllers to always load
        // the provided entity via collection.getById -> then render
        // form or throw notification ("Order was deleted or non-existing").

        if (typeof model !== 'undefined' && model.get('id') === '') {

            const quickOrderForm = new QuickOrderForm();

        } else if (action == 'addpaymentfromreservations') {
            // only undefined if context is reservationsList
            if (typeof model === 'undefined') {

                let context = 'reservations/reservationsList';
                this._addpaymentByOrder(orderId, context);
                
            } else {

                if (typeof canvas == 'object' && canvas != null && typeof canvas.close == 'function') {
                    canvas.close();
                }

                this._collection.fetchById(orderId, function (targetModel) {

                    const offCanvasAddPaymentForm = new OffCanvasAddPayment({
                        model: _.clone(targetModel),
                        orderId: orderId,
                        toggleAddReservation: toggleAddReservation,
                        toggleReservation: toggleReservation,
                        reservationId,
                        collection: that._collection,
                        context: 'reservations/reservationsList'
                    });
                });
                
            }
        } else if (action == 'addpaymentfromorders') {
            // only undefined if context is reservationsList
            if (typeof model === 'undefined') {

                let context = 'reservations/orders';
                this._addpaymentByOrder(orderId, context);

            } else {

                if (typeof canvas == 'object' && canvas != null && typeof canvas.close == 'function') {
                    canvas.close();
                }

                this._collection.fetchById(orderId, function (targetModel) {

                    const offCanvasAddPaymentForm = new OffCanvasAddPayment({
                        model: _.clone(targetModel),
                        orderId: orderId,
                        toggleAddReservation: toggleAddReservation,
                        toggleReservation: toggleReservation,
                        reservationId,
                        collection: that._collection,
                        context: 'reservations/orders'
                    });
                });

            }
        } else if (action == 'addpaymentfromorderedit') {
            // only undefined if context is reservationsList
            if (typeof model === 'undefined') {

                let context = 'orders/'+orderId+'/edit';
                this._addpaymentByOrder(orderId, context);

            } else {

                if (typeof canvas == 'object' && canvas != null && typeof canvas.close == 'function') {
                    canvas.close();
                }

                this._collection.fetchById(orderId, function (targetModel) {

                    const offCanvasAddPaymentForm = new OffCanvasAddPayment({
                        model: _.clone(targetModel),
                        orderId: orderId,
                        toggleAddReservation: toggleAddReservation,
                        toggleReservation: toggleReservation,
                        reservationId,
                        collection: that._collection,
                        context: 'orders/'+orderId+'/edit'
                    });
                });

            }
        } else if (action == 'addpaymentfromwallet') {

            if (typeof model === 'undefined') {

                let context = 'finances';
                this._addpaymentByOrder(orderId, context);

            } else {

                if (typeof canvas == 'object' && canvas != null && typeof canvas.close == 'function') {
                    canvas.close();
                }

                this._collection.fetchById(orderId, function (targetModel) {

                    const offCanvasAddPaymentForm = new OffCanvasAddPayment({
                        model: _.clone(targetModel),
                        orderId: orderId,
                        toggleAddReservation: toggleAddReservation,
                        toggleReservation: toggleReservation,
                        reservationId,
                        collection: that._collection,
                        context: 'finances'
                    });
                });

            }
        } else {

            this._collection.fetchById(orderId, function (targetModel) {

                that.offCanvasOrdersForm = new OffCanvasOrdersForm({
                    model: targetModel,
                    toggleAddReservation: toggleAddReservation,
                    toggleReservation: toggleReservation,
                    collection: that._collection,
                    reservationId,
                    context: 'orders',
                    controller: that
                });
            });
        }
    },

    _addpaymentByOrder (id,context) {

        const that = this,
              RequestHelper = Backbone.Model.extend({ urlRoot : '/orders' });

        return new Promise(
            (resolve, reject) => {

                (new RequestHelper()).save(
                    {
                        id : id,
                    },{
                        type: 'GET',
                        success (model, response) {

                            let _model = new Order();
                            _.extend(_model.attributes,model.attributes.data);                  // copy data of model

                            _model.attributes.reservations = new ReservationsList();            // reservations attribute must be a collection
                            _.each(model.attributes.data.reservations, function(res) {
                                _model.attributes.reservations.add(res);
                            });

                            _model.id = id;
console.log('success: ',_model);
                            const offCanvasAddPaymentForm = new OffCanvasAddPayment({
                                model: _.clone(_model),
                                orderId: id,
                                collection: that._collection,
                                context: context
                            });
                            resolve();
                        },
                        error (model, response) {
                            console.log("Error, could not request order.");
                            reject();
                        }
                    });
            }
        );
    },

    /**
     * @routes /orders/:id[int]/:filename[string]/ics
     */
    createIcs (id,filename) {

        new IcsBuilder({
            'client_id' : Number(Biscuit.get('user.client_id')),
            'order_id' : Number(id)
        }, filename);

    },

    /**
     * @routes /orders/:id[int]/invoice
     * @todo Somehow deprecated - PDF's & co. should NOT be generated in the
     *       frontend; method not working for most clients
     */
    createInvoice (id) {

        this.index();

        const model = this._collection.get(id),
              own_user = Radio.channel('app').request('get:user');

        let user = own_user;

        if (own_user.get('id') !== model.get('user_id')) {
          // Only called when logged in user is manager / admin
          user = Radio.channel('users').request('get:data').get(model.get('user_id'));
        }

        new OffCanvasOrdersInvoiceForm({
            model,
            user,
        });

    },
    
    reservationsList() {

        this.index();
        const reservationsList = new ReservationsList({ collection: this.collection});

    },

    calendar () {
        this._collection._pagination['direction'] = 'asc';
        this._collection._pagination['current_page'] = 0;
        this._collection._pagination['limit'] = 999;                        // add doubled filter param to really trigger refetch
        this._collection.addFilter('finder','NotCancelled');
        // this.collection.setSort('last_name',sort_dir,true);
        this._collection._refetchCollection(true,(success) => {
            this.index('calendar');
            const calendarView = new OrdersCalendarView({collection: this._collection});
        });
    },

    /**
     * @routes /orders/:orderId[int]/payment
     */
    paymentList(orderId) {

        this.index();

        const model = this._collection.get(orderId);

        const offCanvasOrdersForm = new OffCanvasOrdersForm ({
          model,
          collection: this._collection
        });

    },

});
